
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/boende",
      function () {
        return require("private-next-pages/[region]/boende.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/boende"])
      });
    }
  